<template>
    <CompassFormItem
        :label="localizedTexts.date"
        orientation="horizontal"
        :error="textErrorTime"
        size="small"
        class="panel-create-activity__form-date"
    >
        <div class="container-input">
            <CompassDatePicker
                v-show="isAllDay"
                :modelValue="dateRanged"
                range
                datePickerClass="panel-create-activity__datepicker"
                :calendarOptions="{ lang: uiLang, disableWeekDays: disabledWeekDays }"
                class="input-select-date-activity__range"
                @update:modelValue="onUpdateDateRangeInput"
            />
            <div v-show="!isAllDay" class="panel-create-activity__form-date--not-all-day">
                <div>
                    <CompassDatePicker
                        :modelValue="dateStartInput"
                        :calendarOptions="{ lang: uiLang, disableWeekDays: disabledWeekDays }"
                        datePickerClass="panel-create-activity__datepicker"
                        class="input-select-date-activity"
                        @update:modelValue="onUpdateDateStartInput"
                    />
                    <CompassSelect
                        :modelValue="timeStartInput"
                        menuClass="select-time-activity"
                        :error="timeInputIsInError"
                        class="input-select-time-activity"
                        @update:modelValue="updateTimeStartInput"
                    >
                        <CompassDropdownOption
                            v-for="(time, index) in timeList"
                            :key="index"
                            :label="time.label"
                            :value="time.value"
                            type="text"
                        />
                    </CompassSelect>
                </div>
                <div>
                    <CompassDatePicker
                        :modelValue="dateEndInput"
                        :calendarOptions="{
                            lang: uiLang,
                            disableWeekDays: disabledWeekDays,
                            minDate: dateStartInput,
                        }"
                        datePickerClass="panel-create-activity__datepicker"
                        class="input-select-date-activity"
                        @update:modelValue="onUpdateDateEndInput"
                    />
                    <CompassSelect
                        :modelValue="timeEndInput"
                        menuClass="select-time-activity"
                        :error="timeInputIsInError"
                        :autoScroll="true"
                        class="input-select-time-activity"
                        @update:modelValue="updateTimeEndInput"
                    >
                        <CompassDropdownOption
                            v-for="(time, index) in timeList"
                            :key="index"
                            :label="time.label"
                            :value="time.value"
                            type="text"
                        />
                    </CompassSelect>
                </div>
            </div>
            <CompassCheckbox
                :modelValue="true"
                :checked="isAllDay"
                :label="localizedTexts.allDay"
                @change="onIsAllDayChanged"
            />
        </div>
    </CompassFormItem>
</template>

<script>
import ActivityFormPanelDate from 'vcomponents/activities/activitiesFormPanel/ActivityFormPanelDate.vue';
export default {
    extends: ActivityFormPanelDate,
    data() {
        return {
            dateStartInput: '',
            timeStartInput: '',
            dateEndInput: '',
            timeEndInput: '',
            localizedTexts: {
                allDay: this.$l10n.__('Toute la journée'),
            },
            isAllDay: true,
            timeInputIsInError: false,
            MINUTES_INTERVAL: 15,
            dateRanged: [],
        };
    },
    computed: {
        textErrorTime() {
            if (this.timeInputIsInError) {
                return this.$l10n.__(
                    'Les dates renseignées sont en conflit. La date de fin doit être après la date de début',
                );
            }
            return '';
        },
    },
    created() {
        if (this.activityData) {
            this.isAllDay = this.activityData.all_day;
            this.dateRanged = [
                moment(this.activityData.datetime_start).format('YYYY-MM-DD'),
                moment(this.activityData.datetime_end).format('YYYY-MM-DD'),
            ];
            this.dateStartInput = moment(this.activityData.datetime_start).format('YYYY-MM-DD');
            this.dateEndInput = moment(this.activityData.datetime_end).format('YYYY-MM-DD');
            this.getTimeRange(
                moment(this.activityData.datetime_start),
                moment(this.activityData.datetime_end),
            );
        } else {
            this.dateRanged = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
            this.dateStartInput = moment().format('YYYY-MM-DD');
            this.dateEndInput = moment().format('YYYY-MM-DD');
            this.timeStartInput = this.getCurrentTime();
            this.timeEndInput = this.getCurrentTime();
        }
        this.updateDate();
    },
    methods: {
        onIsAllDayChanged(value) {
            this.isAllDay = value;
            this.timeInputIsInError = false;
            this.updateDate();
        },
        onUpdateDateStartInput(value) {
            this.dateStartInput = value;
            const { dateStart, dateEnd } = this.getDatesMoment();
            if (dateEnd.isBefore(dateStart)) {
                this.dateEndInput = this.dateStartInput;
                this.timeEndInput = moment(this.timeStartInput, 'HH:mm')
                    .add(1, 'hours')
                    .format('HH:mm');
            }
            this.updateDate();
        },
        onUpdateDateRangeInput(value) {
            this.dateRanged = value;
            if (this.dateRanged.length > 1) {
                this.updateDate();
            }
        },
        onUpdateDateEndInput(value) {
            this.dateEndInput = value;
            this.updateDate();
        },
        updateTimeStartInput(value) {
            this.timeStartInput = value;
            this.updateDate();
        },
        updateTimeEndInput(value) {
            this.timeEndInput = value;
            this.updateDate();
        },
        getDatesMoment() {
            const timeStartMoment = moment(this.timeStartInput, 'HH:mm');
            const timeEndMoment = moment(this.timeEndInput, 'HH:mm');
            const dateStart = moment(this.dateStartInput);
            const dateEnd = moment(this.dateEndInput);
            dateStart.set({
                hours: timeStartMoment.hours(),
                minutes: timeStartMoment.minutes(),
            });
            dateEnd.set({ hours: timeEndMoment.hours(), minutes: timeEndMoment.minutes() });
            return { dateStart, dateEnd };
        },
        updateDate() {
            let dateStart = moment(this.dateRanged[0]).startOf('day');
            let dateEnd = moment(this.dateRanged[1]).endOf('day');
            if (!this.isAllDay) {
                dateStart = this.getDatesMoment().dateStart;
                dateEnd = this.getDatesMoment().dateEnd;
                this.timeInputIsInError =
                    moment(this.timeEndInput, 'HH:mm').isSameOrBefore(
                        moment(this.timeStartInput, 'HH:mm'),
                    ) && dateEnd.isBefore(dateStart);
            }
            this.$emit('updateFormIsInvalid', this.timeInputIsInError);

            if (this.timeInputIsInError) {
                return;
            }
            dateEnd.set({ millisecond: 0 });
            this.$emit('update:activityDate', {
                datetime_start: dateStart.toISOString(true),
                datetime_end: dateEnd.toISOString(true),
                all_day: this.isAllDay,
            });
        },
        getTimeRange(startDate, endDate) {
            const userStartTime = moment(this.workingHours.start_time, 'HH:mm');
            const userEndTime = moment(this.workingHours.end_time, 'HH:mm');
            const startTime = moment(startDate);
            const endTime = moment(endDate);
            const formattedStartTime = this.getFormattedTime(startTime);
            const formattedEndTime = this.getFormattedTime(endTime);

            if (formattedStartTime.isBefore(userStartTime)) {
                this.timeStartInput = userStartTime.format('HH:mm');
            } else if (formattedStartTime.isAfter(userEndTime)) {
                this.timeStartInput = userEndTime.format('HH:mm');
            } else {
                this.timeStartInput = this.formatTimeInput(startTime);
            }

            if (formattedEndTime.isBefore(userStartTime)) {
                this.timeEndInput = userStartTime.format('HH:mm');
            } else if (formattedEndTime.isAfter(userEndTime)) {
                this.timeEndInput = userEndTime.format('HH:mm');
            } else {
                this.timeEndInput = this.formatTimeInput(endTime);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.panel-create-activity__form-date {
    .container-input {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-1);

        .compass-form-item__input {
            flex-direction: row;
            gap: var(--spacing-3);
        }
        .input-select-time-activity {
            width: 100px;
        }
        .input-select-date-activity__range {
            &:deep(.compass-input) {
                min-width: 120px;
                width: 220px;
            }
        }
    }
    &--not-all-day {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-2);
        & > div {
            display: flex;
            gap: var(--spacing-3);
        }
        .input-select-date-activity {
            &:deep(.compass-input) {
                min-width: 120px;
                width: 120px;
            }
        }
    }
}
</style>
